import { c as _c } from "react/compiler-runtime";
import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { getUserLocationWithShortKeys } from 'commons/location';
import userLocationAtom from './userLocationAtom';
const DEFAULT_LOCATION = {};
const useSetUserLocation = () => {
  const $ = _c(2);
  const setUserLocationAtom = useSetAtom(userLocationAtom);
  let t0;
  if ($[0] !== setUserLocationAtom) {
    t0 = longLocation => {
      const shortLocation = longLocation ? getUserLocationWithShortKeys(longLocation) : DEFAULT_LOCATION;
      const shortLocationStringified = JSON.stringify(shortLocation);
      setUserLocationAtom(shortLocationStringified);
    };
    $[0] = setUserLocationAtom;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const setUserLocation = t0;
  return setUserLocation;
};
export default useSetUserLocation;